// extracted by mini-css-extract-plugin
export default {"bgImage":"bgImage__6VVgB","landingContent":"landingContent__cSRhD","textCenter":"textCenter__v2eue"};